<template>
  <div>
    <b-form @submit.prevent="submit" novalidate>
      <div class="row">
        <div class="col-12">
          <validated-form-textarea name="details" label="Kommentaar:" placeholder="Kommentaar arvele"
                                   v-model="comment" :rows="3" :maxRows="8"
                                   :validator="$validator" validate="max:32000"/>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <submit-button class="float-right" variant="primary">Salvesta</submit-button>
        </div>
      </div>
    </b-form>
  </div>

</template>

<script>
  import ValidatedFormTextarea from '@/components/ValidatedFormTextarea'
  import gateway from '@/services/gateway'

  export default {
    props: ['invoice'],
    components: {ValidatedFormTextarea},
    data() {
      return {
        comment: ''
      }
    },
    methods: {
      submit() {
        this.$validator.validateAll().then((valid) => {
          if (!valid) return
          gateway.post(`/invoices/${this.invoice.id}/comment`, {comment: this.comment}).then(() => this.$emit('done'))
        })
      },
    },
    created() {
      this.comment = this.invoice.comment || ''
    }
  }
</script>
